import React, { useState } from "react";
import {
  Select,
  MyMessage,
  InputField,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneAttraction } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import Pricing from "../../components/Pricing";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import {
  FiImage,
  FiClock,
  FiDollarSign,
  FiPlus,
  FiCompass,
  FiRepeat,
} from "react-icons/fi";

const REPEAT_OPTIONS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const {
    entry_label,
    country_name,
    country_id,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const attraction: any = getOneAttraction();
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const attraction_id = attraction?.attraction_id;
  const [thumbnail, setThumbnail] = useState<any>(attraction?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(attraction?.image_cdn_id);
  const [title, setTitle] = useState<any>(attraction?.title);
  const [venue, setVenue] = useState<any>(attraction?.venue);
  const [venueCapacity, setVenueCapacity] = useState<any>(
    attraction?.venue_capacity
  );
  const [openDays, setOpenDays] = useState<any>(attraction?.open_days);
  const [openedAt, setOpenedAt] = useState<any>(attraction?.opened_at);
  const [closedAt, setClosedAt] = useState<any>(attraction?.closed_at);
  const [email, setEmail] = useState<any>(attraction?.email_address);
  const [phoneNumber, setPhoneNumber] = useState<any>(attraction?.phone_number);
  const [payLink, setPayLink] = useState<any>(attraction?.pay_link);
  const [whatsapp, setWhatsapp] = useState<any>(attraction?.whatsapp);
  const [facebook, setFacebook] = useState<any>(attraction?.facebook);
  const [twitter, setTwitter] = useState<any>(attraction?.twitter);
  const [instagram, setInstagram] = useState<any>(attraction?.instagram);
  const [youtube, setYoutube] = useState<any>(attraction?.youtube);
  const [hashtags, setHashtags] = useState<any>(attraction?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(
    attraction?.google_map_code
  );
  const [latitude, setLatitude] = useState<any>(attraction?.latitude);
  const [longitude, setLongitude] = useState<any>(attraction?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    attraction?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(attraction?.featured);
  const [promoted, setPromoted] = useState<any>(
    attraction?.promoted ? attraction?.promoted : "no"
  );
  const [attractionStatus, setAttractionStatus] = useState<any>(
    attraction?.status
  );
  const [description, setDescription] = useState<any>(attraction?.description);
  const [repeatEvery, setRepeatEvery] = useState<any>(attraction?.repeat_every);
  const [expo, setExpo] = useState<any>(attraction?.expo);
  const [showTop, setShowTop] = useState<any>(attraction?.show_top);

  const [bestTime, setBestTime] = useState<any>(
    attraction?.best_time_to_visit ? attraction?.best_time_to_visit : []
  );

  const [showModal, setShowModal] = useState(false);
  const [collection, setCollection] = useState<any>(
    attraction?.WhatIsArounds ? attraction?.WhatIsArounds : []
  );

  const [pricing, setPricing] = useState<any>(attraction?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const attractionRoutes = "/data/attraction";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneAttractionHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: attraction?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      venue: venue,
      venue_capacity: venueCapacity,
      open_days: openDays,
      opened_at: openedAt,
      closed_at: closedAt,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: attractionStatus,
      featured,
      promoted,
      repeat_every: repeatEvery,
      expo,
      show_top: showTop,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
      subdata: collection?.length > 0 ? collection : [],
      pay_link: payLink,
    };

    const { message, status } = await updateOneContent({
      data_id: attraction_id,
      data: data,
      content: _TYPES_.ATTRACTION,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const toggleRepeat = (val: string) => {
    if (repeatEvery?.toString().split("|").includes(val)) {
      let rep = "";
      repeatEvery
        ?.split("|")
        .filter((day: string) => val !== day)
        .forEach((weekday: string) => (rep += `${weekday}|`));
      setRepeatEvery(rep);
    } else {
      let rep = "";
      if (repeatEvery) {
        [...repeatEvery.split("|"), val].forEach(
          (weekday: string) => (rep += `${weekday}|`)
        );
        setRepeatEvery(rep);
      } else {
        setRepeatEvery(val);
      }
    }
  };

  return (
    <AddPageShell
      backRoute={attractionRoutes}
      eyebrow="DoSee Data • Attractions"
      title="Edit Attraction"
      subtitle={`Update a landmark, sight or experience in ${entry_label || "this destination"}.`}
      icon={<FiCompass className="h-5 w-5" />}
      modals={
        <>
          <ModalDetails
            showModal={showModal}
            onClick={() => setShowModal(false)}
            collection={collection}
            setCollection={setCollection}
          />
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
        </>
      }
      headerActions={
        <MyButton
          onClick={() => setShowModal(true)}
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
        >
          <FiPlus className="h-4 w-4" />
          Sub-attractions
        </MyButton>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneAttractionHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="The hero photo travellers see first."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.ATTRACTION)}
        />
      </AddSection>

      <AddSection title="Basics" hint="Name, venue and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top",
              option: ["no", "yes"],
              preselect:
                showTop !== null && showTop !== undefined
                  ? [{ name: showTop === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Hours & Best Time"
        hint="When the attraction is open and the best season to visit."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            props={{
              id: "open_days",
              title: "Open Days",
              type: "text",
              value: openDays || "",
              onChange: (e: any) => {
                setOpenDays(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "opened_at",
              title: "Opened At",
              type: "time",
              value: openedAt || "",
              onChange: (e: any) => {
                setOpenedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "closed_at",
              title: "Closed At",
              type: "time",
              value: closedAt || "",
              onChange: (e: any) => {
                setClosedAt(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
        <div className="mt-5">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            Best Time To Visit
          </p>
          <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
        </div>
      </AddSection>

      <AddSection
        title="Repeat Schedule"
        hint="Optional — recurring days or annual."
        icon={<FiRepeat className="h-4 w-4" />}
      >
        <div className="flex flex-wrap gap-2">
          {REPEAT_OPTIONS.map((val) => {
            const on = repeatEvery?.toString().split("|").includes(val);
            return (
              <span
                key={val}
                role="button"
                tabIndex={0}
                onClick={() => toggleRepeat(val)}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") && toggleRepeat(val)
                }
                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs cursor-pointer capitalize transition-colors ${
                  on
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                }`}
              >
                {on ? (
                  <MdCheckBox className="text-base" />
                ) : (
                  <MdCheckBoxOutlineBlank className="text-base" />
                )}
                {val}
              </span>
            );
          })}
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Tickets and tiers (optional)."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="attraction_status"
        setStatus={setAttractionStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={attractionStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
